module.exports = __webpack_public_path__ + "static/media/button-video-frame-white.3408118b.svg";